import { ForbiddenError } from '@api/Errors'
import ErrorHandler from '@api/ErrorHandler'

export default class ForbiddenErrorHandler extends ErrorHandler {
  constructor(response) {
    super(response, 'dashboard')
    throw new ForbiddenError('403 Forbidden', response)
  }
}
